import { NumberFormatProps } from "react-number-format";

// Nastavitelne props: https://github.com/s-yadav/react-number-format#props
export type NumberInputFormatConfig = {
  minValue?: number;
  maxValue?: number;
} & Omit<
  NumberFormatProps,
  | "getInputRef"
  | "onValueChange"
  | "isNumericString"
  | "value"
  | "defaultValue"
  | "checked"
  | "defaultChecked"
>;

export const presets = {
  hwr: {
    thousandSeparator: " ",
    decimalScale: 2,
    fixedDecimalScale: true,
    decimalSeparator: ",",
  } as NumberInputFormatConfig,
  nonNegative: {
    minValue: 0,
  },
};

type Presets = typeof presets;
export type NumberInputPresetName = keyof Presets;

export const getFormatConfigIncludingPresets = (
  manualConfig?: NumberInputFormatConfig,
  activePresets: NumberInputPresetName[] = []
): NumberInputFormatConfig => ({
  ...Object.assign({}, ...activePresets.map((name) => presets[name])),
  ...manualConfig,
});
